var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"mt-5",attrs:{"cols":"12"}}),_c('v-col',[_vm._v("Digital Learning Design")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }